import CardBlog from '../../components/CardBlog/CardBlog';
import CardNew from '../../components/CardNew/CardNew';
import { INewLive } from '../../components/SliderLive/interfaces';

export const CardNews = ({ item }: { item: INewLive }) => {
  switch (item.type) {
    case 'blog':
      return <CardBlog {...item} />;
    case 'news':
      return <CardNew {...item} />;
    case 'stretchy':
      return <CardBlog stretchy {...item} />;
    default:
      return <CardNew {...item} />;
  }
};
